module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('nav-menu', {
    attrs: {
      "bgNav": _vm.imgNavPic,
      "menu": _vm.aNavMenu
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('div', {
    staticClass: "text",
    attrs: {
      "id": "text"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgHead
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "article"
  }, [_c('div', {
    staticClass: "tabs"
  }, [_c('tabs-menu', {
    attrs: {
      "menu": _vm.aArticle
    }
  })], 1)])])])], 1)], 1), _vm._v(" "), _c('foot')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-47d01ac3"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/About.vue
// module id = 781
// module chunks = 1